import React, { FC } from 'react'
import { ContentfulRichText } from '@/atoms/ContentfulRichText'
import { FlexColumn } from '@/atoms/FlexContainers'
import { GiveawayDetailsTabText, GiveawayPartnerLogo, Maybe } from '@/types/codegen-contentful'
import { useSafeAnalytics } from '@/utils/analytics'
import { giveawayRichTextOverrides } from '../../../utils/richtextUtils'
import { EmbeddedGiveawayVideo } from '../../EmbeddedGiveawayVideo/EmbeddedGiveawayVideo'
import { GalleryCarousel } from './GalleryCarousel'

interface Props {
  galleryImages?: Maybe<GiveawayPartnerLogo>[]
  trailerId: string | null | undefined
  text?: Maybe<GiveawayDetailsTabText>
  videoThumbnail?: Maybe<string>
}

export const PresaleDetailsTab: FC<Props> = ({ galleryImages, trailerId, videoThumbnail, text }) => {
  const { track } = useSafeAnalytics()

  return (
    <FlexColumn className="mb-16 w-full gap-16 px-4 pt-16 md:gap-[72px] md:px-9 md:pb-32">
      <div className="flex w-full flex-col gap-1">
        {trailerId && (
          <EmbeddedGiveawayVideo
            id="youtube"
            url={`https://www.youtube-nocookie.com/embed/${trailerId}?autoplay=1`}
            thumbnail={videoThumbnail ?? undefined}
            onPlayClick={() => track('Giveaway Video Clicked')}
            containerClassName="my-3 w-full max-w-[361px] md:mb-[72px] md:max-w-[530px]"
            className="mx-auto !rounded-[10px] md:mx-0"
          />
        )}

        {text && (
          <ContentfulRichText json={text.json} links={text.links} renderOptionOverrides={giveawayRichTextOverrides} />
        )}
      </div>

      {!!galleryImages?.length && <GalleryCarousel galleryImages={galleryImages} />}
    </FlexColumn>
  )
}
